import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import GiftFooter from './components/GiftFooter';
import ItemInfo from './components/ItemInfo';
import useGiftItem from './hooks/useGiftItem';

interface Params {
    giftItemId: string;
}

const GiftItemActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { giftItemId } = params;
  const giftItem = useGiftItem(giftItemId);

  return (
      <AppScreen>
          {giftItem && (
              <CtaLayout header={<Header title='선물하기'/>}
                         footer={<GiftFooter giftItem={giftItem}/>} >
                  <ItemInfo gitItem={giftItem}/>
              </CtaLayout>
          )}
      </AppScreen>
  );
};

export default GiftItemActivity;
